import {useSyncExternalStore} from 'react'
import {getSessionGeneration, onSessionGenerationChange} from './sessionGeneration.js'
export function useSessionGeneration() {
  return useSyncExternalStore(onSessionGenerationChange, getSessionGeneration, getSessionGeneration)
}
